"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferDialog = exports.transferValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
var validation_1 = require("./validation");
Object.defineProperty(exports, "transferValidationSchema", { enumerable: true, get: function () { return validation_1.transferValidationSchema; } });
const TransferDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2, 1], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "address", required: true }), (0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid.Empty, {}), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TokenAssetInput, { prefix: "token", required: true, contract: {
                    data: {
                        excludeFeatures: [types_1.ContractFeatures.SOULBOUND],
                    },
                } })] }));
};
exports.TransferDialog = TransferDialog;
//# sourceMappingURL=index.js.map